module.exports = __webpack_public_path__ + "img/it_2.e705e2b9.jpg";